import { createContext, useContext, useState } from 'react';

const ToastContext = createContext();

export const ToastProvider = ({ children }) => {
  const [toast, setToast] = useState(null);

  // `sticky` keeps a non-error toast up until it is closed — for a message
  // too long to read in the usual three seconds.
  const showToast = (message, variant, { sticky = false } = {}) => {
    setToast({ message, variant, sticky });
  };

  const hideToast = () => {
    setToast(null);
  };

  return (
    <ToastContext.Provider value={{ toast, showToast, hideToast }}>
      {children}
    </ToastContext.Provider>
  );
};

export const useToast = () => {
  return useContext(ToastContext);
};
